import { render, staticRenderFns } from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=template&id=6c3a709a&"
import script from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoAutocomplete.vue
// module id = 1325
// module chunks = 28